export const PROJECT_NAME = 'Photo Discovery';

export const API_URL = 'https://jsonplaceholder.typicode.com';

export const APPLICATION_ERROR = 'Aplication error.';
